import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderService } from '../../Services/HeaderService';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-user-template',
	templateUrl: './user-template.component.html',
	styleUrls: ['./user-template.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class UserTemplateComponent implements OnInit {

	private subscription: Subscription[] = [];
	headerSettings = {};
	constructor(private _headerService: HeaderService, private _titleService: Title) {
		_titleService.setTitle('Preview');
		this.subscription.push(_headerService.headerSettings.subscribe(data => {
			this.headerSettings = data;
		}))
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// ./src/app/user-template/user-template.component.ts